import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log('Login attempt:', { email, passwordLength: password.length });
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      console.error('Response:', error.response);
      console.error('Response data:', error.response?.data);
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="glass-panel rounded-2xl p-8 border">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold mb-2" data-testid="login-title">Welcome Back</h1>
            <p className="text-muted-foreground">Login to your Blendonics account</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1"
                data-testid="login-password-input"
              />
            </div>
            <Button
              type="submit"
              className="w-full rounded-full transition-all duration-300"
              disabled={loading}
              style={{ background: '#D4AF37', color: '#141414', fontWeight: '600' }}
              data-testid="login-submit-button"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
          <div className="mt-6 text-center text-sm">
            <span className="text-muted-foreground">Don't have an account? </span>
            <Link to="/signup" className="hover:underline" style={{ color: '#D4AF37' }} data-testid="login-signup-link">
              Sign up
            </Link>
          </div>
          <div className="mt-3 text-center text-sm">
            <Link to="/forgot-password" className="hover:underline" style={{ color: '#a3a3a3' }} data-testid="forgot-password-link">
              Forgot your password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;